import {
  GET_BAISHUN_GAMES,
  GET_BAISHUN_HISTORY,
  UPDATE_BAISHUN_GAME_STATUS,
} from "./type";

const initialState = {
  games: [],
  history: [],
  stats: {
    totalGames: 0,
    totalDiamondsSpent: 0,
    totalDiamondsWon: 0,
    houseProfit: 0,
  },
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
    limit: 20,
  },
};

export const baishunHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BAISHUN_GAMES:
      return {
        ...state,
        games: action.payload,
      };
    case GET_BAISHUN_HISTORY:
      return {
        ...state,
        history: action.payload.history,
        stats: action.payload.stats,
        pagination: action.payload.pagination,
      };
    case UPDATE_BAISHUN_GAME_STATUS:
      return {
        ...state,
        games: state.games.map((game) =>
          game.gameId === action.payload.gameId
            ? { ...game, isEnabled: action.payload.isEnabled }
            : game,
        ),
      };
    default:
      return state;
  }
};
